import MUIDataTable from "mui-datatables";
import { styled, createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import Highlighter from "react-highlight-words";
import { useContext, useEffect, useState } from "react";
import { ProjectContext } from "../screens/ProjectScreen";
import { TermDocsTableTheme } from "../config/config";
import { Button } from "react-bootstrap";
import axios from "axios";
import { api } from "../services/config";
import Loader from "./Loader";
import { useMemo } from "react";
import { paramsSerializer } from "../utils/utils";

const theme = createTheme(TermDocsTableTheme);

function TermDocsTable() {
  const {
    projectId, headers,
    termData,
  } = useContext(ProjectContext);
  const [docs, setDocs] = useState([])
  const [loading, setLoading] = useState(false);
  const [showDocs, setShowDocs] = useState(false)

  useEffect(() => {
    setShowDocs(false)
    setDocs([])
  }, [termData])

  const columns = useMemo(() => [
    {
      name: "filename",
      label: "Nom de fichier",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "matches",
      label: "Contexte",
      options: {
        filter: false,
        sort: false,
        customBodyRender: customBodyRender(termData?.reference),
      },
    }
  ], [termData?.reference]);

  const options = useMemo(() => ({
    filterType: "checkbox",
    selectableRows: "none",
    filter: false,
    search: false,
    print: false,
    download: false,
    viewColumns: false,
    rowsPerPageOptions: [2, 5, 10],
    tableBodyHeight: "calc(100% - 41px)",
    textLabels: {
      body: {
        noMatch: loading ? (
          <Loader>Chargement des données ...</Loader>
        ) : (
          "Désolé, il n'y a pas de données correspondantes à afficher"
        ),
      },
    }
  }), [loading])

  const getDocs = async () => {
    setShowDocs(true)
    setLoading(true)
    const params = {
      limit: 100,
    }
    await axios.get(
      `${api.project}${projectId}/terms/${termData.id}/docs/`,
      {
        params,
        paramsSerializer,
      },
      { headers }
    )
      .then(({ data }) => {
        setDocs(data.docs);
        setLoading(false)
      })
      .catch(
        function (error) {
          setLoading(false)
          return Promise.reject(error)
        }
      )
  }

  return (
    <div style={{ flex: 1, height: "100%" }}>
      {showDocs
        ? <MuiThemeProvider theme={theme}>
          <MUIDataTable
            data={docs}
            columns={columns}
            options={options} />
        </MuiThemeProvider>
        : <Button
          className='m-1 p-1'
          size="sm"
          onClick={getDocs}
          disabled={!termData?.id}
        >
          Voir le terme en contexte
        </Button>
      }
    </div>
  );
}

const StyledHighlighter = styled(Highlighter)({
  '& .highlightClass': {
    backgroundColor: 'yellow',
    fontWeight: 'bold',
  },
});

const customBodyRender = (termReference) => {
  return (matches) => matches.map(match => <span
    className="highlighterContainer"
  >
    <StyledHighlighter
      key={match}
      highlightClassName="highlightClass"
      searchWords={[termReference || ""]}
      autoEscape={true}
      textToHighlight={match}
    />
  </span>)
}

export default TermDocsTable
